import {
  Component,
  Input,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { take } from 'rxjs/operators';
import { AlarmLimit } from 'src/app/model/operational-monitoring/alarm-limit';
import { AlarmLimitHistory } from 'src/app/model/operational-monitoring/alarm-limit-history';
import { OperationalMonitoringApiService } from 'src/app/services/api/operational-monitoring-api.service';
import { Dialog } from '@openng/optimus-ui/dialog';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-alarm-limit-audit-trail',
  templateUrl: './alarm-limit-audit-trail.component.html',
  styleUrls: ['./alarm-limit-audit-trail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Dialog, ProgressSpinner, DatePipe],
})
export class AlarmLimitAuditTrailComponent {
  private _opMonitoring = inject(OperationalMonitoringApiService);

  @Input() isVisible: boolean = false;
  readonly selectedAlarmLimit = input<AlarmLimit>();

  readonly dialogHidden = output();

  isLoading: boolean = false;
  histories: AlarmLimitHistory[] = [];

  onDialogHide() {
    this.dialogHidden.emit();
  }

  getHistories(): void {
    this.isLoading = true;
    let parentId = this.selectedAlarmLimit()!.id;
    this._opMonitoring
      .getAlarmLimitHistories(parentId)
      .subscribe((histories) => {
        this.histories = histories;
        this.isLoading = false;
      });
  }
}
